import { render, staticRenderFns } from "./CriarCotacaoDePedidoDeCompraView.vue?vue&type=template&id=4b8d58ac&scoped=true"
import script from "./CriarCotacaoDePedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarCotacaoDePedidoDeCompraView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CriarCotacaoDePedidoDeCompraView.vue?vue&type=style&index=0&id=4b8d58ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8d58ac",
  null
  
)

export default component.exports